import { render, staticRenderFns } from "./regulationList.vue?vue&type=template&id=35f3b670&scoped=true&"
import script from "./regulationList.vue?vue&type=script&lang=js&"
export * from "./regulationList.vue?vue&type=script&lang=js&"
import style0 from "./regulationList.vue?vue&type=style&index=0&id=35f3b670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3b670",
  null
  
)

export default component.exports